import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { CustomStyles, getStyles } from "src/styles/theme";
import defaultStyles, { StylesClasses } from "./styles";

type NotificationBadgeProps = {
  customStyles?: CustomStyles<StylesClasses>;
  additionalComponent?: React.ReactNode;
  icon?: string | React.ReactElement<any>;
  tabHeaders: {
    label: string;
    value: string;
  }[];
  iconPosition?: "bottom" | "top" | "end" | "start";
  components?: React.ReactNode[];
  onChange?: (e: string) => void;
  tabIndex?: number;
};

const HorizontalTabs = ({
  tabHeaders,
  customStyles,
  additionalComponent,
  icon,
  iconPosition,
  components,
  onChange,
  tabIndex = 0,
}: NotificationBadgeProps) => {
  const styles = getStyles<StylesClasses>(defaultStyles, customStyles);
  const [tab, setTab] = useState(tabIndex);

  // Keep the highlighted tab in sync when the active tab is changed from
  // outside (e.g. the "Filter By Status" dropdown), not just by clicking a tab.
  useEffect(() => {
    setTab(tabIndex);
  }, [tabIndex]);

  return (
    <Box>
      <Tabs
        value={tab}
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        onChange={(event, tab) => {
          setTab(tab);
          onChange && onChange(tabHeaders[tab]?.value);
        }}
        {...styles("flexContainer")}
      >
        {tabHeaders.map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
            icon={icon}
            iconPosition={iconPosition}
            {...styles("tab")}
          />
        ))}
        {additionalComponent}
      </Tabs>
      <Box mt={2}>{components[tab]}</Box>
    </Box>
  );
};

export default HorizontalTabs;
